import { get, merge } from 'lodash'
import { getDrupalSetting } from '@ggs/utils'

/**
 * A query function to retrieve search data from the API
 * @param {number} lat - latitude coordinates
 * @param {number} lng - longitude coordinates
 * @param {string} searchTerm - keyword or search topic
 * @param {boolean=} cupwFilter - apply CUPW filter to search
 * @param {number=} pageIndex - current page index
 * @param {number=} distance - search distance
 * @param {string=} serviceLanguage - service language filter
 * @param {string=} sort - sort modes (distance, best, name)
 * @param {boolean=} removeDigital
 * @return {Promise<import("../../definitions/Search211ApiTypes").Search211Response>}
 */

const get211Data = async (
  lat,
  lng,
  searchTerm,
  cupwFilter = false,
  pageIndex = 0,
  distance = 50,
  serviceLanguage = '',
  sort = 'distance',
  removeDigital = false
) => {
  if (!lat || !lng) throw new Error('Cannot search without location data')

  const language = get(window || {}, 'drupalSettings.path.currentLanguage', 'en').toLowerCase()

  let searchParams = {
    Dataset: 'ca',
    Lang: language,
    SearchType: 'proximity',
    Latitude: lat,
    Longitude: lng,
    Distance: distance,
    Fields:
      'LanguagesOffered, LanguagesOfferedList, DisabilitiesAccess, TaxonomyCodes, TaxonomyTerm, TaxonomyTerms, Eligibility',
    Languages: serviceLanguage,
    PageIndex: pageIndex,
    PageSize: 250,
    SortOrder: sort,
    RequirePhysicalAddress: removeDigital ? 1 : 0,
  }

  if (cupwFilter) {
    searchParams = merge(searchParams, {
      Search: 'match',
      MatchMode: 'taxcodes',
      MatchTerms: searchTerm,
    })
  } else {
    searchParams = merge(searchParams, {
      Search: 'term',
      Term: searchTerm,
    })
  }

  console.log('### SEARCH PARAMS ###')
  console.table(searchParams)

  const apiKey211 = getDrupalSetting('apiKey') || `${process.env.REACT_APP_CUPW211_API_KEY}`
  const apiEndpoint = getDrupalSetting('apiEndpoint') || `${process.env.REACT_APP_CUPW211_API_ENDPOINT}`
  const response = await fetch(`${apiEndpoint}/search?key=${apiKey211}`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(searchParams),
  })

  const data = await response.json()
  if (data.Error) {
    console.error('Error data:', data)
    throw new Error(`${data.Error['API Error'] ?? 'Unknown error, try again later.'}`)
  } else if (!response.ok) {
    throw new Error('Unknown error, try again later.')
  }

  console.log(data)

  localStorage.removeItem('resultDistances')

  return {
    ...data,
    RecordCount: parseInt(data.RecordCount),
  }
}

export default get211Data
